import React, { PureComponent } from 'react';
import { Route, Switch } from 'react-router-dom';

import List from './list';

export default class Stock extends PureComponent {
  render() {
    return (
      <Switch>
        <Route component={List} exact path={this.props.match?.path} />
      </Switch>
    );
  }
}
